import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Global } from '../../../../global/global';
import { enumMessageTypes } from '../../common/common-enums';
import { commonMessage } from '../../common/common-message';
import { BaseEntryForm } from './base-entry-form';
import { BehaviorSubject, Observable } from 'rxjs';
import { WrapperStandardRequest, WrapperStandardRequestCustom } from '../../common/models/wrapper.model';



export class GenericEntryFormProperties<T, S> extends BaseEntryForm<T> {

    private _formMode: number = 0;
    private _routeTo: string = "";
    private _validationMessages: Array<string> = new Array<string>();

    private _validationMessage: Array<any> = new Array<any>();


    private _key: number = 0;
    private _guid: string = "";

    private _entryFormDataSource: any;
    private _entryFormDataSourceSAP: any;
 private _requestData: WrapperStandardRequestCustom<any> = new WrapperStandardRequestCustom<any>();
    private _urlForFormModeEdit: string = "";
    private _editFormRequestData: any;
    private _urlForFormModeAdd: string = "";
    private _urlForFormModeUpdate: string = "";
    private _urlForFormModeNew: string = "";
    private _requesDataForFormModeNew: any;
    private _messages: Array<commonMessage> = new Array<commonMessage>();
    private _formTitle: string = "";
    private _formSubTitle: string = "";
    private _menuCode: string = "";
    private _urlForFormModeAddSap: string = "";
    private _urlForFormModeUpdateSap: string = "";
    private _formModeDisable: boolean = false;
    private _currentPage: number = 0;
    private isPagination: boolean = true;
    private _pageRecordCount: number = 0;
    private _pageSize: number = 0;
    private _rowCount: number = 0;
    private _entryFormDataSourceForScrollPagination: Array<T> = [];
    private _paginatorPageLength: number = 0;
    private _paginatorPageIndex: number = 0;
    private _paginatorPageSize: number = 0;
    private _paginatorPageSizeOptions: Array<number> = [10, 20, 40, 50];

    public formSubmittedSubject: BehaviorSubject<string> = new BehaviorSubject<string>('')
    public formSubmittedObs: Observable<string> = this.formSubmittedSubject.asObservable();
     get getRequestData(): WrapperStandardRequestCustom<any> {
        return this._requestData;
    };


    set setRequestData(value: WrapperStandardRequestCustom<any>) {
        this._requestData = value;
    };

    public get getFormMode(): number {
        return this._formMode;
    };

    public set setFormMode(value: number) {
        this._formMode = value;
    };

    public get getValidationMessage(): Array<any> {
        return this._validationMessage;
    };

    public set setValidationMessage(value: Array<any>) {
        this._validationMessage = value;
    };

    public get getListViewFormRouteTo(): string {
        return this._routeTo;
    };

    public set setListViewFormRouteTo(value: string) {
        this._routeTo = Global.getRouteVForms.concat(value);
    };

    public get getValidtionMessages(): Array<string> {
        return this._validationMessages;
    };

    public set setValidationMessages(value: Array<string>) {
        this._validationMessages = value;
    };

    public get getKey(): number {
        return this._key;
    };

    public set setKey(value: number) {
        this._key = value;
    };

    public get getGuid(): string {
        return this._guid;
    };

    public set setGuid(value: string) {
        this._guid = value;
        if (this._guid == '0') {
            this.setKey = 0;
        }
        else {
            this.setKey = 1;
        }
    };

    public get getEntryFormDataSource(): T {
        return this._entryFormDataSource;
    };

    public set setEntryFormDataSource(value: T) {
        this._entryFormDataSource = value;
    };




    public get getURLForFormModeNew(): string {
        return this._urlForFormModeNew;
    };

    public set setURLForFormModeNew(value: string) {
        this._urlForFormModeNew = Global.getApiUrl.concat(value);
    };

    public get getRequestDataForFormModeNew(): any {
        return this._requesDataForFormModeNew;
    };

    public set setRequestDataForFormModeNew(value: any) {
        this._requesDataForFormModeNew = value;
    };

    public get getURLForFormModeEdit(): string {
        return this._urlForFormModeEdit;
    };

    public set setURLForFormModeEdit(value: string) {
        this._urlForFormModeEdit = Global.getApiUrl.concat(value);
    };

    public get getRequestDataForFormModeEdit(): any {
        return this._editFormRequestData;
    };

    public set setRequestDataForFormModeEdit(value: any) {
        this._editFormRequestData = value;
    };

    public get getURLForFormModeAdd(): string {
        return this._urlForFormModeAdd;
    };

    public set setURLForFormModeAdd(value: string) {
        this._urlForFormModeAdd = Global.getApiUrl.concat(value);
    };

    public get getURLForFormModeUpdate(): string {
        return this._urlForFormModeUpdate;
    };

    public set setURLForFormModeUpdate(value: string) {
        this._urlForFormModeUpdate = Global.getApiUrl.concat(value);
    };

    public get getMessages(): Array<commonMessage> {
        return this._messages;
    };

    public set setMessages(value: Array<commonMessage>) {
        this._messages = value;
    };

    public get getFormTitle(): string {
        return this._formTitle;
    };

    public set setFormTitle(value: string) {
        this._formTitle = value;
    };

    public get getFormSubTitle(): string {
        return this._formSubTitle;
    };

    public set setFormSubTitle(value: string) {
        this._formSubTitle = value;
    };

    public get getMenuCode(): string {
        return this._menuCode;
    };

    public set setMenuCode(value: string) {
        this._menuCode = value;
    };

    public get getURLForFormModeAddSap(): string {
        return this._urlForFormModeAddSap;
    };

    public set setURLForFormModeAddSap(value: string) {
        this._urlForFormModeAddSap = Global.getApiUrlSap.concat(value);
    };

    public get getURLForFormModeUpdateSap(): string {
        return this._urlForFormModeUpdateSap;
    };

    public set setURLForFormModeUpdateSap(value: string) {
        this._urlForFormModeUpdateSap = Global.getApiUrlSap.concat(value);
    };

    public get getEntryFormDataSourceSAP(): S {
        return this._entryFormDataSourceSAP;
    };

    public set setEntryFormDataSourceSAP(value: S) {
        this._entryFormDataSourceSAP = value;
    };


    // Events Declarations
    constructor() {
        super();

        this._messages = new Array<commonMessage>();
        this.setKey = 0;
         this.setPaginatorPageSize = 0;
        this.setPaginatorPageLength = 0;
        this.setPaginatorPageIndex = 0;

    };



    //Route Navigation
    private _objectType: string = "";

    public get getObjectType(): string {
        return this._objectType;
    }
    public set setObjectType(value: string) {
        this._objectType = value;
    };

    public get getFormDisable(): boolean {
        return this._formModeDisable;
    };

    public set setFormDisable(value: boolean) {
        this._formModeDisable = value;
    };
    // public get getFormDisable(): boolean {
    //     return this._formModeDisable;
    // };

    // public set setFormDisable(value: boolean) {
    //     this._formModeDisable = value;
    // };


    public get getPaginatorPageLength(): number {
        return this._paginatorPageLength;
    };

    public set setPaginatorPageLength(value: number) {
        this._paginatorPageLength = value;
    };

    public get getPaginatorPageIndex(): number {
        return this._paginatorPageIndex;
    };

    public set setPaginatorPageIndex(value: number) {
        this._paginatorPageIndex = value;
    };

    public get getPaginatorPageSize(): number {
        return this._paginatorPageSize;
    };

    public set setPaginatorPageSize(value: number) {
        this._paginatorPageSize = value;
    };

    public get getPaginatorPageSizeOptions(): Array<number> {
        return this._paginatorPageSizeOptions;
    };

    public set setPaginatorPageSizeOptions(value: Array<number>) {
        this._paginatorPageSizeOptions = value;
    };
    public get getEntryFormDataSourceOnScrollPagination(): Array<T> {
        return this._entryFormDataSourceForScrollPagination;
    };
    public set setEntryFormDataSourceOnScrollPagination(value:any) {
        if (value.length == 0) {
            this._entryFormDataSourceForScrollPagination = [];
        }
        this.getIsPagination ? this._entryFormDataSourceForScrollPagination.push(value)
            : this._entryFormDataSourceForScrollPagination = value;
    };

    public get getIsPagination(): boolean {
        return this.isPagination
    };

    public set setIsPagination(isPagination: boolean) {
        this.isPagination = isPagination;
    };

    public get getCurrentPage(): number {
        return this._currentPage;
    };
    public set setCurrentPage(value: number) {
        this._currentPage = value;
    };
    public get getPageRecordCount(): number {
        return this._pageRecordCount;
    };
    public set setPageRecordCount(value: number) {
        this._pageRecordCount = value;
    };
    public get getPageSize(): number {
        return this._pageSize;
    };
    public set setPageSize(value: number) {
        this._pageSize = value;
    };
    public get getRowCount(): number {
        return this._rowCount;
    };
    public set setRowCount(value: number) {
        this._rowCount = value;
    };

}
